import clsx from 'clsx'
import React, { BaseHTMLAttributes, FC, PropsWithChildren, ReactNode, useRef } from 'react'

import { ImageV4 } from '@Components/Image'

import styles from './AccordionImageCheckbox.module.scss'

export interface AccordionImageCheckboxProps {
  className?: string
  defaultChecked?: boolean
  header: ReactNode | string
  id: string
  imgSrc?: string
  name?: string
  onClick?: BaseHTMLAttributes<HTMLInputElement>['onClick']
}

export const AccordionImageCheckbox: FC<PropsWithChildren<AccordionImageCheckboxProps>> = ({ children,
  className,
  defaultChecked,
  header,
  id,
  imgSrc,
  name,
  onClick }) => {
  const ref = useRef<HTMLDivElement | null>(null)
  return (
    <div className={clsx(styles.accordionItem, className)} ref={ref}>
      <input
        className={styles.accordionItemCheckbox}
        defaultChecked={defaultChecked}
        id={id}
        name={name}
        onClick={(e) => {
          ref.current?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'start' })
          if (onClick) {
            onClick(e)
          }
        }}
        type={name ? 'radio' : 'checkbox'}
      />
      <div className={styles.accordionHeaderAndContent}>
        <label htmlFor={id}>
          {imgSrc && <ImageV4 draggable={false} src={imgSrc} width={250} />}
          {header}
        </label>
        <div className={styles.accordionContent}>
          {children}
        </div>
      </div>
    </div>
  )
}

